import RequestHandler from '../../customize/requestHandler';

export const getNotification = async (limit = 5, page = 1) => {
	return RequestHandler.call({ url: `/api/v1/notifications?limit=${limit}&page=${page}`, method: 'get' }).then(res => res.data);
};

export const getAllNotification = async (limit = 10, page = 1) => {
	return RequestHandler.call({ url: `/api/v1/notifications?limit=${limit}&page=${page}`, method: 'get' }).then(res => res.data);
};

export const viewNotification = async (id: number) => {
	return RequestHandler.call({ url: `/api/v1/notifications/${id}`, method: 'put', data: { viewed: true } }).then(res => res.data);
};

export const GetAnnouncement = async () => {
	return RequestHandler.call({ url: `/api/v1/announcments?limit=5&page=1`, method: 'get' }).then(res => res.data.result);
};
